<template>
  <v-container fluid>
    <v-card class="pb-2">
      <v-card-title primary-title style="padding-left:8px;padding-bottom:8px">
        <span class="headline mb-0">设置do号码</span>
      </v-card-title>

      <v-card-actions>
        <v-btn @click="openDoNo">set doNo</v-btn>
      </v-card-actions>
    </v-card>
    <input-do-no @popData="setDoNumber" ref="doNo"></input-do-no>
  </v-container>
</template>
<script>
import InputDoNo from './InputDoNo'
export default {
  components: { InputDoNo },
  methods: {
    save() {
      Promise.all(
        this.results.map(s => {
          return this.$http.put(`/shipping-advices/${s.id}`, s)
        })
      )
    },
    setDoNumber(item) {
      this.doInfo.doNo = item.doNo
      this.doInfo.blNo = item.blNo
      this.$http.put('shipping-advices/setDo', this.doInfo).then(() => {
        return this.$message('', 'doNo 設置に成功する')
      })
    },
    toDetail(item) {
      this.$refs.blDetail.popup(item.id).then(order => {
        this.setDirectors(order)
      })
    },
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable()
        }
      }
    },
    openDoNo() {
      this.$refs.doNo.popup()
    },
    back() {
      this.$router.go(-1)
    }
  },
  data() {
    return {
      doInfo: {
        doNo: '',
        blNo: ''
      }
    }
  }
}
</script>


